/* eslint-disable no-param-reassign */
/* eslint-disable max-len */

export const formatTime = (time: Date): string => {
  const hours = time.getHours();
  const minutes = time.getMinutes();
  const amOrPm = hours >= 12 ? 'pm' : 'am';
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes}${amOrPm}`;
};

export const customMultiSelectStyles = {
  control: (base: any) => ({
    ...base,
    borderRadius: '999px',
    border: '1px solid #009FE3',
    backgroundColor: '#fff',
    minHeight: '34px',
    paddingLeft: '16px',
    paddingRight: '8px',
    boxShadow: 'none',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#009FE3',
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: 0,
    flexWrap: 'nowrap',
    overflow: 'hidden',
  }),
  multiValue: () => ({
    display: 'none',
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    color: '#009FE3',
  }),
  clearIndicator: (base: any) => ({
    ...base,
    display: 'none',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    padding: 4,
    color: '#009FE3',
    paddingLeft: '8px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  placeholder: (base: any) => ({
    ...base,
    fontWeight: 500,
    color: '#009FE3',
    fontSize: '13px',
    textTransform: 'uppercase',
  }),
  singleValue: (base: any) => ({
    ...base,
    fontWeight: 500,
    color: '#009FE3',
    fontSize: '13px',
    textTransform: 'uppercase',
  }),
  option: (base: any) => ({
    ...base,
    backgroundColor: '#fff',
    color: '#172433',
    fontWeight: 500,
    fontSize: '16px',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    cursor: 'pointer',
  }),
  menu: (base: any) => ({
    ...base,
    borderRadius: '12px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    marginTop: 8,
    zIndex: 20,
  }),
};
